module.exports = __webpack_public_path__ + "img/paper_airplane.98ccbc5d.svg";